import scrollToView from 'lib/utils/scroll-to-view'

export default function scrollToError (containerSelector, timeout = 150, adjustment = -90) {
  window.setTimeout(() => {
    const firstError = window.document.querySelectorAll(`${containerSelector} .simple-error`)[0]
    if (firstError) {
      scrollToView({ element: firstError, adjustment })
    }
  }, timeout)
}
